import { useIntl } from 'react-intl';
import { useTitleStore } from 'src/stores/useTitleStore';
import * as React from 'react';
import { chargesMessages } from 'src/features/charges/utils/messages';
import ChargesTable from 'src/features/charges/components/tables/ChargesTable';

const ChargesLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(chargesMessages.charges));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <ChargesTable />;
};

export default ChargesLayout;
